var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9.08957C3 4.82636 6.33799 2 10 2C13.662 2 17 4.82636 17 9.08957C17 10.8705 15.9257 12.5367 14.6637 13.956C13.4854 15.2813 12.0267 16.5164 10.7966 17.5581C10.691 17.6474 10.5872 17.7354 10.4853 17.8218C10.2054 18.0594 9.7946 18.0594 9.51467 17.8218C9.41281 17.7353 9.30896 17.6474 9.20342 17.558C7.97327 16.5164 6.51458 15.2813 5.33627 13.956C4.07431 12.5367 3 10.8705 3 9.08957ZM10 3.5C7.10876 3.5 4.5 5.71129 4.5 9.08957C4.5 10.2905 5.24637 11.5974 6.45725 12.9593C7.50667 14.1396 8.80477 15.2536 10 16.2669C11.1952 15.2536 12.4933 14.1396 13.5428 12.9593C14.7536 11.5974 15.5 10.2905 15.5 9.08957C15.5 5.71129 12.8912 3.5 10 3.5ZM10 7.64286C9.25956 7.64286 8.66667 8.23853 8.66667 8.96429C8.66667 9.69004 9.25956 10.2857 10 10.2857C10.7404 10.2857 11.3333 9.69004 11.3333 8.96429C11.3333 8.23853 10.7404 7.64286 10 7.64286ZM7.16667 8.96429C7.16667 7.40201 8.43925 6.14286 10 6.14286C11.5607 6.14286 12.8333 7.40201 12.8333 8.96429C12.8333 10.5266 11.5607 11.7857 10 11.7857C8.43925 11.7857 7.16667 10.5266 7.16667 8.96429Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "6f9cf5b7bc4370223984c8425a7e6f9b.svg";
export { ForwardRef as ReactComponent };